import ReducerRegistry from 'jitsi/base/redux/ReducerRegistry';
import { UPDATE_SHOW_CAMERA_OFF_PARTICIPANTS } from './actions';
const DEFAULT_STATE = {
    hideCameraOffParticipants: false,
};
export const STORE_NAME = 'iisight/features/video-grid';
ReducerRegistry.register(STORE_NAME, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case UPDATE_SHOW_CAMERA_OFF_PARTICIPANTS:
            return {
                ...state,
                hideCameraOffParticipants: action.state,
            };
        default:
            return state;
    }
});
